/* @flow */
import Unread from 'entities/Unread';
import Collection from 'lib/Collection';

class Unreads extends Collection<Unread> {
  initialize() {
    // $FlowIssue
    this.url = '/notifications/unread';
    this.model = Unread;
  }

  parse(response: Object) {
    if (response.unreads) {
      return response.unreads.concat(response['group_unreads'] || []);
    }
    return [];
  }
}

export default Unreads;
